export const STATUS = {
  PENDING: 'pending',
  REQUIRED: 'required'
};

export const TYPES = {
  ECOMM: 'eComm',
  PGUIDE: "pGuide"
}